module.exports = __webpack_public_path__ + "img/icon-bank-details.a5905d52.svg";